import { call, take, fork, all, put } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { cookies } from 'src/utils';
import { fetchJson } from 'src/utils/fetch';
import { SpecialistActionTypes } from './type';
// import format from 'src/utils/format';

function* getSpecialistBaseConfig() {
  while (true) {
    const action = yield take(SpecialistActionTypes.SPECIALIST_BASE_CONFIG);
    try {
      const { payload: { data = {}, configLocation = 'homeConfig' } = {} } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/specialism/clinic/queryIndexInfo',
        type: 'POST',
        needLoading: true,
        needLogin: false,
        data: {
          option: {
            needDcotorInfo: true,
            needPregnancyArchives: true,
            needDcotorImage: true,
            needFilterExcludeResource: true,
          },
          channelResourceCode: cookies.get('channelResourceCode') || '',
          ...data,
        },
      });
      if (res && res.code === '0') {
        let { result = [] } = res;
        const dataConfig = {};
        result = result.map((k) => {
          const { pregnancyArchivesDomain = {}, medicalStaffDomain: { attachmentList: [attachmentItem = {}] = [] } = {} } = k;
          let expectedBirthDay = 0;
          let item = { ...k, headPortrait: attachmentItem.attachmentDownloadUrl };
          if (pregnancyArchivesDomain.expectedBirthDate) {
            const targeDate = new Date(pregnancyArchivesDomain.expectedBirthDate.replace(/-/g, '/'));
            const nowDate = new Date();
            const diffTime = targeDate.getTime() - nowDate.getTime();
            expectedBirthDay = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            item = { ...item, pregnancyArchivesDomain: { ...pregnancyArchivesDomain, expectedBirthDay } };
          }
          dataConfig[`category${k.homeType}`] = item;
          return item;
        });
        yield put({
          type: SpecialistActionTypes.SPECIALIST_BASE_CONFIG_REDUCER,
          data: {
            [`${configLocation}`]: result,
            ...dataConfig,
          },
        });
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试1');
    }
  }
}

export default function* root() {
  yield all([fork(getSpecialistBaseConfig)]);
}
